export default {
  name: "SearchSolid",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "m29.56 27.44-7.81-7.81C23.16 17.79 24 15.49 24 13c0-6.07-4.93-11-11-11S2 6.93 2 13s4.93 11 11 11c2.49 0 4.79-.84 6.63-2.25l7.81 7.81c.59.59 1.54.59 2.12 0s.59-1.53 0-2.12zM5 13c0-4.41 3.59-8 8-8s8 3.59 8 8-3.59 8-8 8-8-3.59-8-8z",
  },
}
